// Actions
export const REGISTER_COMPLETION = 'COMPLETION/REGISTER_COMPLETION'
export const HYDRATE_COMPLETION = 'COMPLETION/HYDRATE_COMPLETION'

// Commits
export const SET_COMPLETION = 'COMPLETION/SET_COMPLETION'
export const RESET_STATE = 'COMPLETION/RESET_STATE'
